import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const EmailSuccessIcon = createIcon({
    viewBox: '0 0 120 120',
    path: (
        <>
            <Path
                d='M37.3333 45.9926C37.3063 46.3071 37.1666 46.6029 36.9377 46.8253L21.3333 61.9843V102H98V61.9843L83.0631 47.4871C82.833 47.2638 82.6929 46.9664 82.6667 46.6503M44.4851 81.8268L37.3333 75.6972L21.3333 61.9843M98 102L74.8482 81.8268L60.5465 69.3651C60.0432 68.9265 59.2901 68.9265 58.7868 69.3651L44.4851 81.8268L21.3333 102M98 61.9843L82.6667 75.1259M74.8482 81.8268L82.6667 75.1259M37.3333 75.6972V45.9926M37.3333 45.9926V38.1732C37.3333 37.4426 37.9303 36.8504 38.6667 36.8504H38.7386M37.3333 45.9926C37.3362 45.9591 37.3378 45.9254 37.3381 45.8916L37.4053 38.1618C37.4116 37.4357 38.0067 36.8504 38.7386 36.8504M38.7386 36.8504H46.6196M46.6196 36.8504H72.7137M46.6196 36.8504C46.9701 36.8504 47.3066 36.7134 47.5561 36.4692L58.7302 25.5309C59.2494 25.0226 60.0839 25.0226 60.6031 25.5309L71.7773 36.4692C72.0268 36.7134 72.3632 36.8504 72.7137 36.8504M72.7137 36.8504H81.2607M81.2607 36.8504H81.3333C82.0697 36.8504 82.6667 37.4426 82.6667 38.1732V46.6503M81.2607 36.8504C81.9929 36.8504 82.5881 37.4362 82.594 38.1626L82.6622 46.5522C82.6625 46.585 82.664 46.6178 82.6667 46.6503M82.6667 75.1259V46.6503M52.3333 55.7008L57.3333 60.6614L67.6667 50.4094M26.6667 40.4882L18 34.5354M40.3333 27.2598L33.3333 18M79.3333 27.5906L86.3333 18.3307M93 41.1496L102 34.5354'
                stroke='currentColor'
                strokeWidth='1.33333'
                strokeLinecap='round'
            />
        </>
    ),
})

EmailSuccessIcon.displayName = 'EmailSuccessIcon'
